// @ts-nocheck
/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Engage UIApi endpoints
 * API to be used only by the engage UI
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetContractResponse
} from '../engageUIApiEndpoints.schemas';

import { customInstance } from '../../client';
import type { ErrorType } from '../../client';




/**
 * @summary getContract
 */
export const getContract = (
    contractNumber: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetContractResponse>(
      {url: `/api/ui/contracts/${contractNumber}`, method: 'GET', signal
    },
      );
    }
  



export const getGetContractQueryKey = (contractNumber?: string,) => {
    return [
    `/api/ui/contracts/${contractNumber}`
    ] as const;
    }

    
export const getGetContractQueryOptions = <TData = Awaited<ReturnType<typeof getContract>>, TError = ErrorType<unknown>>(contractNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractQueryKey(contractNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContract>>> = ({ signal }) => getContract(contractNumber, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contractNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractQueryResult = NonNullable<Awaited<ReturnType<typeof getContract>>>
export type GetContractQueryError = ErrorType<unknown>


export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = ErrorType<unknown>>(
 contractNumber: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContract>>,
          TError,
          Awaited<ReturnType<typeof getContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = ErrorType<unknown>>(
 contractNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContract>>,
          TError,
          Awaited<ReturnType<typeof getContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = ErrorType<unknown>>(
 contractNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getContract
 */

export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = ErrorType<unknown>>(
 contractNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractQueryOptions(contractNumber,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




